/**
 * Rotas que NÃO exigem autenticação.
 * Qualquer path que comece com um destes valores será permitido sem login.
 */
export const PUBLIC_ROUTES: readonly string[] = [
  '/login',
  // Adicione aqui outras rotas públicas, por exemplo:
  // '/esqueci-senha',
  // '/cadastro',
];

export function isPublicUrl(url: string): boolean {
  const path = url.split('?')[0];
  return PUBLIC_ROUTES.some((route) => path === route || path.startsWith(route + '/'));
}
